<template>
<div>
  <div v-if="showMockLogin" class="mock-login-page">
    <div class="mock-login-card">
      <div class="mock-login-badge">卡密获取请加QQ群：1098075883</div>
      <h1 class="mock-login-title">欢迎登录</h1>
      <p class="mock-login-subtitle">请输入账号和密码进入系统</p>
      <div class="mock-login-form">
        <div class="mock-input">
          <span class="mock-input-label">账号</span>
          <span class="mock-input-placeholder">请输入登录账号</span>
        </div>
        <div class="mock-input">
          <span class="mock-input-label">密码</span>
          <span class="mock-input-placeholder">请输入登录密码</span>
        </div>
        <div class="mock-login-options">
          <span>记住密码</span>
          <span>忘记密码</span>
        </div>
        <div class="mock-login-button">登录</div>
      </div>
    </div>
    <div class="beian-footer">
      <a
        class="beian-link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        鲁ICP备2025176774号-1
      </a>
    </div>
  </div>
  <div v-else>
  <!-- 全屏状态栏 -->
    <div v-if="isInFullscreen" class="status-bar">
      <div class="status-bar-left">
        <span class="time">{{ currentTime }}</span>
        <img class="carrier-icon" src="@/assets/imag/mt.jpg" alt="Carrier Icon">
      </div>
      <div class="status-bar-right">
        <span class=network-speed>{{ networkSpeed }}<br>KB/s</span>
        <img class="carrier-icon" style="height: 15px;" src="@/assets/imag/信号5G.png" alt="Carrier Icon">
        <img class="carrier-icon" src="@/assets/imag/dt_dianliang.png" alt="Carrier Icon">
      </div>
    </div>
  <!-- 使用vant的loading组件 -->
    <van-loading
      v-if="loading"
      type="spinner"
      color="#1989fa"
      vertical
    >
      加载中...
    </van-loading>

    <!-- 错误信息展示 -->
    <van-empty
      v-else-if="error"
      image="error"
      :description="errorMessage"
    >
      <van-button
        round
        type="primary"
        @click="getPxInfoBySignToken"
      >
        重试
      </van-button>
    </van-empty>
    <div class="training-details-page" v-else>
    <!-- 顶部标题栏 -->
    <header class="header" :class="{ 'with-status-bar': isInFullscreen }">
      <div class="back-icon-container">
        <svg class="back-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z" fill="currentColor"></path>
        </svg>
      </div>
      <h1 class="header-title">培训详情</h1>
      <!-- <div class="header-action"  @click="openScanner">
         扫码签到
      </div> -->
    </header>
    <div class="header-subtitle-container">

    <!-- 测试按钮（开发用，可删除） -->
     <!-- <div class="test-buttons" style="display: flex; gap: 10px; padding: 10px 15px; background: #fff; border-bottom: 1px solid #f0f0f0;">
      <van-button size="small" type="primary" @click="testSuccess">测试成功弹窗</van-button>
      <van-button size="small" type="danger" @click="testExpiring">测试失效弹窗</van-button>
    </div>  -->

    <!-- 主要内容区域 -->
    <main class="content">
      <div class="important-notice" v-if="useDoubleCode">
        重要提醒：签到、签退均成功后，才视为完成培训。
      </div>
      <span v-if="headerSubtitleText" class="header-subtitle">{{ headerSubtitleText }}</span>
      <div class="main-title">
        {{details.pxTitle}}
      </div>

      <div class="info-section">
        <h2 class="section-title">参培信息</h2>

        <div class="info-item">
          <span class="label">时间</span>
          <span class="value">{{ details.pxTimeStr }}</span>
        </div>
        <div class="info-item">
          <span class="label">地址</span>
          <span class="value">{{ details.pxAddres }}</span>
        </div>
        <div class="info-item">
          <span class="label">讲师</span>
          <span class="value contact-person">
            {{ details.pxLxr }}
            <a href="#" class="contact-link">
              <van-icon name="phone" />
              拨打讲师隐私号
            </a>
          </span>
        </div>
        <div class="info-item" v-if="signInTimeRange">
          <span class="label">签到</span>
          <span class="value">{{ signInTimeRange }}</span>
        </div>
        <div class="info-item" v-if="signOutTimeRange">
          <span class="label">签退</span>
          <span class="value">{{ signOutTimeRange }}</span>
        </div>
      </div>

      <div class="info-section">
        <h2 class="section-title">培训介绍</h2>
        <p class="section-content" v-html="details.pxMsg"></p>
      </div>

      <div class="info-section">
        <h2 class="section-title">参培要求</h2>
        <p class="section-content" v-html="details.pxYq"></p>
      </div>
    </main>
    </div>
    <div class="bottom-fixed">
    <!-- 底部内容，比如按钮、导航等 -->
     <div class="footer-content"><van-button  size="large" @click="openScanner" color="#f9dc3a"><p style="color:#23250d;font-weight: 550;">{{ actionButtonText }}</p></van-button></div>
    </div>
<!-- 引用子组件 -->
    <!-- 所有培训场次统一使用新版扫码组件。 -->
    <qr-scanner-new
      v-model="showPhoto"
      :visible="showPhoto"
      :qr-code-valid-duration="details?.effectiveTime"
      :lose-out-time="details?.loseOutTime"
      @scan-success="handleNewSuccess"
      @scan-closed="showPhoto = false"
      @scan-expired="scanExpired"
    />
    <van-popup v-model="showCenter" round :style="{ width: '90%', height: '155px' }">
      <div class="main-body popup-content">
        <div class="popup-top">
          <div class="ico-header" :class="{ 'error-icon': showError }">
            <van-icon v-if="!showError" name="checked" />
            <div v-else class="error-icon-circle">
              <!-- <van-icon name="warning-o" /> -->
            </div>
          </div>
          <div style="display: flex; flex-direction: column;">
          <div class="font-content">
            <div v-if="showError" class="error-title">签到失败</div>
            <div v-else>{{msg}}</div>
        </div>

        </div>
        </div>
         <div v-if="showError">
            <span style="font-size: 15px; font-weight: 500;">{{msg}}</span>
        </div>
        <div class="popup-bottom">
          <div class="footer-content"><van-button size="large" @click="closeCenterPopup" color="#f9dc3a"><p style="color:#23250d;font-weight: 550;">我知道了</p></van-button></div>
        </div>
      </div>

    </van-popup>
    <van-popup v-model="showQp" round :style="{ width: '90%', height: '300px' }">
      <div class="main-body">
        <div class="ico-header" style="color: orange;"><van-icon name="info-o" /></div>
        <div class="font-content">{{msg2}}</div>
        <div class="footer"><van-button round size="large" @click="enterFullscreen" color="#fed000"><p style="color:black">去签到</p></van-button></div>
      </div>
    </van-popup>
  </div>
  </div>
  </div>
</template>

<script>
// 1. 引入组件
import { Notify, Toast, Loading } from 'vant';
import { getPxInfoBySignToken, GenerateQRode } from '@/api/index';
import QrScannerNew from './QrScannerNew.vue';

const PAGE_READY_MESSAGE = '即将开始扫码，请准备！！！';
const DEFAULT_REALTIME_MESSAGE = '请等候更新..';

export default {
  name: 'Login',
  // 2. 注册组件
  components: {
    QrScannerNew,
  },
  created() {
    const { query = {}, params = {} } = this.$route || {};
    const keyScrent = params.keyScrent || query.keyScrent;

    this.keyScrent = keyScrent;
    if (!keyScrent) {
      this.showMockLogin = true;
      this.loading = false;
      this.error = false;
      this.isHidden = false;
      return;
    }
    this.isHidden = true;
    this.getPxInfoBySignToken(keyScrent);

    // 添加时钟更新
    this.updateTime();
    setInterval(this.updateTime, 60000); // 每分钟更新一次时间

    setInterval(this.updateNetworkSpeed, 3000);
    this.updateNetworkSpeed(); // 初始化网络速度
  },
  computed: {
    useDoubleCode() {
      return ['Y', '1', 1, true].includes(this.isTwo);
    },
    currentMinutes() {
      if (!this.currentTime) {
        return null;
      }
      return this.parseTimeToMinutes(this.currentTime);
    },
    signInTimeRange() {
      if (!this.useDoubleCode) {
        return '';
      }
      const range = this.getSignTimeRanges();
      return range.signIn;
    },
    signOutTimeRange() {
      if (!this.useDoubleCode) {
        return '';
      }
      const range = this.getSignTimeRanges();
      return range.signOut;
    },
    headerSubtitleText() {
      if (!this.useDoubleCode) {
        return '待签到';
      }
      if (this.shouldShowPendingSignIn) {
        return '待签到';
      }
      if (this.doubleCodePhase === 'signOut') {
        return '已签到，培训结束后及时签退';
      }
      // 如果是签到阶段但不在签到时间范围内（如培训日期不是今天），也显示"待签到"
      if (this.doubleCodePhase === 'signIn') {
        return '待签到';
      }
      return '';
    },
    actionButtonText() {
      if (this.useDoubleCode && this.doubleCodePhase === 'signOut') {
        return '扫码签退';
      }
      return '扫码签到';
    },
    effectiveSignInSwitchThreshold() {
      const count = Number(this.details?.signInSwitchCount);
      if (Number.isNaN(count) || count < 1) {
        return 3;
      }
      return count;
    },
    signInSwitchMode() {
      return this.details?.signInSwitchMode || 'COUNT';
    },
    shouldShowPendingSignIn() {
      if (!this.useDoubleCode || this.signInSwitchMode === 'SIGNED') {
        return false;
      }
      const rangeMinutes = this.getSignTimeRangeMinutes();

      if (!rangeMinutes || this.currentMinutes === null) {
        return false;
      }
      return this.doubleCodePhase !== 'signOut'
        && this.signInSuccessCount < this.effectiveSignInSwitchThreshold
        && this.currentMinutes >= rangeMinutes.signInStart
        && this.currentMinutes < rangeMinutes.signInEnd;
    },
  },
  data() {
    return {
      isTwo: true,
      doubleCodePhase: 'signIn',
      signInSuccessCount: 0,
      signInSwitchThreshold: 3,
      isAuthorized: false, // 是否已授权
      networkSpeed: '0.00', // 网络速度
      loading: true,
      error: false,
      showMockLogin: false,
      isHidden: true,
      show: false,
      msg: '签到成功',
      msg2: '请参加培训后扫码签到',
      showCenter: false,
      showError: false, // 是否显示错误弹窗
      // 是否全屏
      showQp: true,
      // 3. 添加状态来控制子组件的显隐
      showPhoto: false, // 新版扫码组件显示状态
      // 时间状态
      currentTime: '',
      // 电池电量
      batteryLevel: 85,
      // 全屏状态
      isInFullscreen: false,
      // 将页面所有动态数据都放在 data 中
      details: {
      },
      keyScrent: '',
      // WebSocket 相关
      ws: null,
      // WebSocket 尚未连接时暂存扫码界面的最新状态，连接成功后立即补发。
      pendingWsMessage: '',
      // wsUrl: 'ws://localhost:8080/web-qrcode',
      wsUrl: process.env.VUE_APP_WS_URL,
    };
  },
  watch: {
    showPhoto(visible, previousVisible) {
      // 无论通过关闭按钮、扫码完成、扫码过期还是初始化失败退出，都恢复默认实时消息。
      if (previousVisible && !visible) {
        this.sendWebSocketMessage(DEFAULT_REALTIME_MESSAGE);
      }
    },
  },
  methods: {

    // 判断是否为苹果设备（包括iOS和macOS）
    isAppleDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod|macintosh/.test(userAgent);
    },

    // 判断是否为iOS设备
    isIOS() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },

    // 判断是否为macOS设备
    isMacOS() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /macintosh/.test(userAgent) && !this.isIOS();
    },
    updateNetworkSpeed() {
      // 模拟网络速度更新
      this.networkSpeed = `${Math.floor(Math.random() * 100).toString()}.${Math.floor(Math.random() * 100).toString()}`;
    },
    // 4. 定义方法来打开子组件（扫码或拍照）
    openScanner() {
      if (!this.isHidden) {
        Notify({ type: 'danger', message: '请求参数错误，请重试！' });
        return;
      }
      if (this.show) {
        Notify({ type: 'danger', message: '该链接已超时，请联系管理员！' });
        return;
      }

      this.syncDoubleCodePhaseByRule();
      this.sendWebSocketMessage(this.getScannerReadyMessage());
      this.showPhoto = true;
    },
    parseTimeToMinutes(timeText) {
      const [hours, minutes] = timeText.split(':').map(Number);
      if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return null;
      }
      return (hours * 60) + minutes;
    },
    formatMinutes(minutes) {
      const total = ((minutes % 1440) + 1440) % 1440;
      const hours = Math.floor(total / 60).toString().padStart(2, '0');
      const mins = (total % 60).toString().padStart(2, '0');
      return `${hours}:${mins}`;
    },
    getSignTimeRangeMinutes() {
      const timeText = this.details?.pxTimeStr || '';
      const matches = timeText.match(/\d{1,2}:\d{2}/g);
      if (!matches || matches.length < 2) {
        return null;
      }
      const startMinutes = this.parseTimeToMinutes(matches[0]);
      const endMinutes = this.parseTimeToMinutes(matches[matches.length - 1]);
      if (startMinutes === null || endMinutes === null) {
        return null;
      }
      return {
        signInStart: startMinutes - 30,
        signInEnd: startMinutes + 10,
        signOutStart: endMinutes - 20,
        signOutEnd: endMinutes,
      };
    },
    getTrainingDurationMinutes() {
      const timeText = this.details?.pxTimeStr || '';
      const matches = timeText.match(/\d{1,2}:\d{2}/g);
      if (!matches || matches.length < 2) {
        return null;
      }
      const startMinutes = this.parseTimeToMinutes(matches[0]);
      const endMinutes = this.parseTimeToMinutes(matches[matches.length - 1]);
      if (startMinutes === null || endMinutes === null) {
        return null;
      }
      const duration = endMinutes - startMinutes;
      return duration >= 0 ? duration : duration + 1440;
    },
    getScannerReadyMessage() {
      const trainingDuration = this.getTrainingDurationMinutes();
      if (!this.useDoubleCode || trainingDuration === null || trainingDuration < 30) {
        return '！！！请打开扫码框，准备扫码！！！';
      }
      const actionText = this.doubleCodePhase === 'signOut' ? '签退' : '签到';
      return `！！！请打开扫码框，准备${actionText}！！！`;
    },
    isTrainingToday() {
      const timeText = this.details?.pxTimeStr || '';
      const dateMatch = timeText.match(/(\d{4}-\d{2}-\d{2})/);
      if (!dateMatch) {
        return false;
      }
      const trainingDate = dateMatch[1];
      const today = new Date().toISOString().split('T')[0];
      return trainingDate === today;
    },
    getSignTimeRanges() {
      const rangeMinutes = this.getSignTimeRangeMinutes();
      if (!rangeMinutes) {
        return {
          signIn: '',
          signOut: '',
        };
      }
      return {
        signIn: `${this.formatMinutes(rangeMinutes.signInStart)}~${this.formatMinutes(rangeMinutes.signInEnd)}`,
        signOut: `${this.formatMinutes(rangeMinutes.signOutStart)}~${this.formatMinutes(rangeMinutes.signOutEnd)}`,
      };
    },
    getSignStateStorageKey() {
      return `px-sign-state-${this.keyScrent || 'default'}`;
    },
    restoreDoubleCodeState() {
      if (!this.useDoubleCode) {
        this.doubleCodePhase = 'signIn';
        this.signInSuccessCount = 0;
        return;
      }
      if (this.signInSwitchMode === 'SIGNED') {
        this.doubleCodePhase = 'signOut';
        this.signInSuccessCount = 0;
        this.persistDoubleCodeState();
        return;
      }
      try {
        const raw = window.localStorage.getItem(this.getSignStateStorageKey());
        if (!raw) {
          this.syncDoubleCodePhaseByRule();
          return;
        }
        const saved = JSON.parse(raw);
        this.doubleCodePhase = saved.phase === 'signOut' ? 'signOut' : 'signIn';
        this.signInSuccessCount = Number.isInteger(saved.signInSuccessCount) ? saved.signInSuccessCount : 0;
      } catch (e) {
        this.doubleCodePhase = 'signIn';
        this.signInSuccessCount = 0;
      }
      this.syncDoubleCodePhaseByRule();
    },
    persistDoubleCodeState() {
      if (!this.useDoubleCode) {
        return;
      }
      window.localStorage.setItem(this.getSignStateStorageKey(), JSON.stringify({
        phase: this.doubleCodePhase,
        signInSuccessCount: this.signInSuccessCount,
      }));
    },
    syncDoubleCodePhaseByRule() {
      if (!this.useDoubleCode) {
        this.doubleCodePhase = 'signIn';
        return;
      }
      if (this.signInSwitchMode === 'SIGNED') {
        this.doubleCodePhase = 'signOut';
        this.persistDoubleCodeState();
        return;
      }
      const rangeMinutes = this.getSignTimeRangeMinutes();
      if (!rangeMinutes || this.currentMinutes === null) {
        this.persistDoubleCodeState();
        return;
      }
      // 如果培训日期不是今天，保持签到状态
      if (!this.isTrainingToday()) {
        this.doubleCodePhase = 'signIn';
        this.persistDoubleCodeState();
        return;
      }
      if (this.currentMinutes >= rangeMinutes.signInEnd || this.signInSuccessCount >= this.effectiveSignInSwitchThreshold) {
        this.doubleCodePhase = 'signOut';
      } else {
        this.doubleCodePhase = 'signIn';
      }
      this.persistDoubleCodeState();
    },
    handleDoubleCodeSuccess() {
      const actionPhase = this.doubleCodePhase;
      if (this.useDoubleCode && this.signInSwitchMode === 'SIGNED') {
        this.doubleCodePhase = 'signOut';
        this.persistDoubleCodeState();
        return 'signOut';
      }
      if (this.useDoubleCode && actionPhase === 'signIn') {
        this.signInSuccessCount += 1;
        this.syncDoubleCodePhaseByRule();
        return actionPhase;
      }
      return actionPhase;
    },
    // 更新当前时间
    updateTime() {
      const now = new Date();
      this.currentTime = `${now.getHours().toString().padStart(2, '0')}:${
        now.getMinutes().toString().padStart(2, '0')}`;
      this.syncDoubleCodePhaseByRule();
    },

    // 模拟电池电量更新
    updateBatteryLevel() {
      // 模拟电池电量在80-95%之间变化
      this.batteryLevel = Math.floor(Math.random() * 16) + 80;
    },
    // 进入全屏
    enterFullscreen() {
    // 如果是苹果设备，则不执行全屏操作
      if (this.isAppleDevice()) {
        // console.log('苹果设备不支持全屏，跳过全屏操作');
        // this.isInFullscreen = true; // 仍然设置状态为全屏，以显示状态栏
        this.showQp = false;
        return;
      }
      this.showQp = false; // 关闭弹框
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) { /* Safari */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { /* IE11 */
        element.msRequestFullscreen();
      }
      // 设置全屏状态
      this.isInFullscreen = true;
    },

    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
      // 添加: 更新全屏状态
      this.isInFullscreen = false;
    },

    // 检查是否全屏
    isFullscreen() {
      return !!(
        document.fullscreenElement
      || document.webkitFullscreenElement
      || document.msFullscreenElement
      );
    },

    // 切换全屏
    toggleFullscreen() {
      if (this.isFullscreen()) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    // 校验
    isValid32CharLowerHexString(str) {
      // 允许数字、字母和下划线，长度不超过200
      return /^[0-9a-zA-Z_]{1,200}$/.test(str);
    },
    async getPxInfoBySignToken(keyScrent) {
      this.loading = true;
      this.error = false;
      try {
        const response = await getPxInfoBySignToken(keyScrent);
        if (response.code === 500) {
          Toast.fail(response.msg);
          this.show = true;
          this.error = true;
          this.errorMessage = response.msg;
          return;
        } if (response.code === 200) {
          this.details = response.data;
          this.isTwo = response.data && response.data.isTwo;
          this.restoreDoubleCodeState();
          this.show = false;
          // 是否需要认证，根据返回数据中的isAuthorized字段判断
          this.isAuthorized = response.data && response.data.isAuthor === '1';
          this.keyScrent = this.details.keyScrent;
          // 连接 WebSocket 并发送页面打开消息
          this.connectWebSocket(this.isAuthorized);
        }
      } catch (err) {
        // 请求出错（如500错误）
        const errorMsg = '服务器错误';
        this.error = true;
        this.errorMessage = errorMsg;
      } finally {
        this.loading = false;
      }
    },

    handleNewSuccess(qrCodeData, count, isExpiring) {
      // qrCodeData 就是从二维码中解析出的文字标识
      // isExpiring: 二维码是否即将失效（剩余时间<5秒）
      // console.log('扫描到的标识:', qrCodeData, '是否即将失效:', isExpiring);
      this.showPhoto = false;
      if (this.isValid32CharLowerHexString(qrCodeData)) {
        // 后台接口
        this.details.pxUuid = qrCodeData;
        GenerateQRode(this.details).then((response) => {
          //  console.log(response)
          // 签到成功
          if (response.code === 200) {
            // 如果二维码即将失效，显示失败弹窗
            if (isExpiring) {
              this.signInSuccessCount = 0;
              this.syncDoubleCodePhaseByRule();
              this.showError = true;
              this.msg = '扫码失败，二维码已失效，请重新扫码';
              this.showCenter = true;
            } else {
              // 正常情况显示成功弹窗
              const actionPhase = this.handleDoubleCodeSuccess();
              this.showError = false;
              this.msg = actionPhase === 'signOut' ? '签退成功' : '签到成功';
              this.showCenter = true;
            }
          } else {
            this.signInSuccessCount = 0;
            this.syncDoubleCodePhaseByRule();
            Toast.fail(response.msg);
          }
        });
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },
    // 二维码失效过期
    scanExpired() {
      this.showPhoto = false;
      this.signInSuccessCount = 0;
      this.syncDoubleCodePhaseByRule();
      this.showError = true;
      this.msg = '扫码失败，二维码已失效，请重新扫码';
      this.showCenter = true;
    },
    // WebSocket 相关方法
    connectWebSocket(isAuthorized) {
      this.cleanupWebSocket();

      try {
        let url = this.wsUrl;
        if (this.keyScrent) {
          const param = `clientId=${encodeURIComponent(this.keyScrent)}`;
          const param2 = `isAuthor=${isAuthorized}`;
          const param3 = 'isQs=true';
          url += (url.indexOf('?') === -1 ? '?' : '&') + param;
          url += (url.indexOf('?') === -1 ? '?' : '&') + param2;
          url += (url.indexOf('?') === -1 ? '?' : '&') + param3;
        }
        this.ws = new WebSocket(url);

        this.ws.onopen = () => {
          // console.log('✅ 页面 WebSocket 连接成功');
          // 页面进入只提示即将开始；只有真正打开扫码框后才发送红色语音标记。
          const scannerStatusMessage = this.pendingWsMessage
            || (this.showPhoto ? this.getScannerReadyMessage() : PAGE_READY_MESSAGE);
          this.pendingWsMessage = '';
          this.sendWebSocketMessage(scannerStatusMessage);
        };

        this.ws.onmessage = (event) => {
          // console.log('📨 页面 WebSocket 收到消息:', event.data);
        };

        this.ws.onerror = (error) => {
          // console.error('❌ 页面 WebSocket 错误:', error);
        };

        this.ws.onclose = () => {
          // console.log('🔌 页面 WebSocket 连接关闭');
        };
      } catch (e) {
        // console.error('💥 页面 WebSocket 连接异常:', e);
      }
    },

    cleanupWebSocket() {
      if (this.ws) {
        try {
          this.ws.close();
        } catch (e) {}
        this.ws = null;
      }
    },

    // 发送 WebSocket 消息的方法（供子组件调用）
    sendWebSocketMessage(message) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        try {
          const msg = {
            type: 'control',
            controlType: 'BROADCAST_SCAN_COUNT',
            clientId: this.keyScrent,
            message,
          };
          this.ws.send(JSON.stringify(msg));
          this.pendingWsMessage = '';
          // console.log('📤 父组件发送消息:', message);
        } catch (e) {
          this.pendingWsMessage = message;
          console.warn('发送消息失败:', e);
        }
      } else {
        // 生产环境连接速度较慢时，扫码组件可能先打开；保留最新状态等待 onopen 补发。
        this.pendingWsMessage = message;
        console.warn('WebSocket 未连接，无法发送消息');
      }
    },

    // 关闭弹窗
    closeCenterPopup() {
      // 先关闭弹窗
      this.showCenter = false;
      // 延迟重置状态，避免出现短暂的成功标识
      setTimeout(() => {
        this.showError = false;
        this.msg = '签到成功'; // 重置消息
      }, 300);
    },

    // 测试方法：模拟成功情况
    testSuccess() {
      // 模拟一个有效的二维码数据
      const testQrCode = `d_riYUdw_${Date.now()}_1206752`;
      const testCount = 20; // 模拟扫码次数大于19
      const isExpiring = false;
      // console.log('🧪 测试成功接口弹窗');
      if (this.isValid32CharLowerHexString(testQrCode)) {
        // 真实流程，走handleNewSuccess（会自动调接口并正常展示倒计时、弹窗等）
        this.handleNewSuccess(testQrCode, testCount, isExpiring);
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },

    // 测试方法：模拟即将失效情况
    testExpiring() {
      // 模拟一个即将失效的二维码（生成时间是15秒前，剩余时间只有5秒）
      const expiredTime = Date.now() - 15000; // 15秒前生成
      const testQrCode = `d_riYUdw_${expiredTime}_1206752`;
      // 模拟扫码次数大于19
      const testCount = 20;
      // 模拟即将失效（isExpiring = true）
      const isExpiring = true;

      // console.log('🧪 测试失效弹窗');

      // 直接模拟接口成功的情况，避免实际调用接口
      if (this.isValid32CharLowerHexString(testQrCode)) {
        // 模拟接口返回成功
        // 如果二维码即将失效，显示失败弹窗
        if (isExpiring) {
          this.showError = true;
          this.msg = '扫码失败，二维码已失效，请重新扫码';
          this.showCenter = true;
        } else {
          // 正常情况显示成功弹窗
          this.showError = false;
          this.msg = '签到成功';
          this.showCenter = true;
        }
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },
  },
  beforeDestroy() {
    // 主页面退出后恢复二维码显示页的默认实时消息。
    this.sendWebSocketMessage(DEFAULT_REALTIME_MESSAGE);
    this.cleanupWebSocket();
  },
};
</script>

<style scoped lang='less'>
/* 添加状态栏样式 */
.status-bar {
   position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background-color: #757575;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    font-size: 12px;
    color: #fff;
    z-index: 9999;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.status-bar-left {
  display: flex;
  align-items: center;
}

.status-bar-left .carrier-icon {
    width: 15px;
    height: auto;
    margin-left: 5px;
    border-radius: 3px;
}
.status-bar-right .carrier-icon {
    width: 24px;
    height: auto;
    margin-left: 5px;
}

.signal-strength {
  display: flex;
  margin-right: 5px;
}

.signal-bar {
  width: 2px;
  height: 8px;
  background-color: #999;
  margin-right: 1px;
}

.signal-bar.full {
  background-color: #FFF;
  height: 14px;
}

.signal-bar.half {
  background-color: #FFF;
  height: 7px;
  margin-top: 7px;
}

.carrier {
  margin-left: 5px;
}

.status-bar-center .time {
  font-weight: 500;
}

.status-bar-right {
  display: flex;
  align-items: center;
  .network-speed {
    font-size: 8px;
    color: #fff;
  }
}

.battery {
  display: flex;
  align-items: center;
  border: 1px solid #000;
  padding: 1px;
  width: 24px;
  height: 12px;
  position: relative;
}

.battery-level {
  height: 100%;
  background-color: #000;
}

.battery-text {
  margin-left: 5px;
}
/* 基础重置和全局样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.error-message {
  color: #ee0a24;
  margin-top: 10px;
}
.main-body{
    width: 100%;
    height: 100%;
    position: relative;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.popup-content {
    justify-content: flex-start;
}

.popup-top {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}

.popup-top .ico-header {
    margin-right: 8px;
}

.popup-bottom {
    width: 100%;
    display: flex;
    justify-content: center;
}

.popup-bottom .footer-content {
    width: 100%;
}
.footer{
  //  position: absolute;
   width: 90%;
  //  bottom: 20px;
}
.font-content{
    font-size: 20px;
    font-weight: bold;
    display: contents;
}
.ico-header{
    // position: absolute;
    // top: 30px;
    color: #00ab5c;
    font-size: 1.5rem;
}

.ico-header.error-icon {
    color: #ee0a24;
}

.error-icon-circle {
    width: 25px;
    height: 25px;
    /* 移除圆角和背景色 */
    /* border-radius: 50%; */
    /* background-color: #ee0a24; */

    /* 添加背景图片 */
    background-image: url('@/assets/imag/感叹号.png');
    background-size: cover;      /* 确保图片覆盖整个区域 */
    background-position: center; /* 图片居中显示 */
    background-repeat: no-repeat; /* 不重复 */

    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.error-icon-circle .van-icon {
    color: #fff;
    font-size: 3rem;
}

.error-title {
  font-size: 20px;
    font-weight: bold;
    // margin-bottom: 10px;
}
/* 页面容器，模拟手机屏幕 */
.training-details-page {
 font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  background-color: #f8f8f8; /* 页面整体为白色背景 */
  color: #020202;
  /* 2. 移除固定高度，让页面自适应内容高度 */
  min-height: 100vh; /* 确保内容少时页面也能铺满屏幕 */
  width: 100%;
  max-width: 480px; /* 在PC上模拟手机宽度 */
  margin: 0 auto; /* 在PC上居中显示 */
//   padding: 20px 16px; /* 为页面内容提供内边距 */
}
.header-subtitle-container{
  position: absolute;
  top: 60px; /* 顶部标题栏高度 */
  width: 100%;
}
/* 顶部标题栏 */
.header {
   position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 65px; /* 设置固定高度 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #f8f8f8;
  z-index: 1000;
}

// 添加: 当有状态栏时，header需要下移
.header.with-status-bar {
  padding-top: env(safe-area-inset-top, 20px);
  height: calc(60px + env(safe-area-inset-top, 20px));
}

.header-title {
  padding-right: 44px;
  font-size: .9rem;
  font-weight: 550;
  color: #020202;
  /* 绝对定位实现完美居中 */
  flex: 1;
  text-align: center;
  // position: absolute;
  letter-spacing: 0.1rem;
   margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-subtitle{
    padding-left: 15px;
    font-size: 1rem;
    font-weight: bold;
    letter-spacing: 0.1rem;
    line-height: 40px;
}

.back-icon-container {
   width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.back-icon {
   width: 21px;
  height: 21px;
  color: #333;
}

.header-action {
  font-size: 14px;
  color: #333;
}

/* 主要内容区域 */
.content {
  margin: 0 10px;
  flex-grow: 1; /* 占据剩余的所有空间 */
//   overflow-y: auto; /* 内容超出时可以滚动 */
  // background-color: #ffffff; /* 内容区域为白色背景 */
//   padding: 0 16px;
  /* 为固定的底部按钮留出空间 */
  padding-bottom: 100px; /* 大于底部固定区域高度，确保内容不被遮挡 */
}
.footer-content{
    padding: 10px 20px 10px 20px;
}
.main-title {
  margin-bottom: 10px;
  background-color: #ffffff;
  line-height: 25px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #000;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
}
.important-notice {
  margin-bottom: 10px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #fff7f0;
  color: #f18143;
  font-size: 0.72rem;
  font-weight: 549;
  line-height: 1.5;
}

/* 信息区块 */
.info-section {
  margin-bottom: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 15px 8px;
//   border-bottom: 1px solid #f0f0f0;
}
.info-section:last-of-type {
  border-bottom: none;
}

.section-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #252525;
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  font-size: 0.85rem;
  line-height: 1.6;
  margin-bottom: 8px;
}

.label {
  color: #747474;
  min-width: 45px;
  flex-shrink: 0; /* 防止标签被压缩 */
  display: flex;
  align-items: center; /* 垂直居中 */
//   margin-right: 5px;
}

.value {
  color: #292929;
//   margin-left: 10px
}

.contact-person {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.contact-link {
  display: flex;
  align-items: center;
  color: #3182CE; /* 蓝色链接 */
  text-decoration: none;
  font-size: 0.9rem;
  margin-left: 12px;
}

.phone-icon {
  margin-right: 4px;
}

.section-content {
  font-size: 0.8rem;
  line-height: 1.3; /* 增加行高，提升可读性 */
  color: #9f9f9f;
  letter-spacing: 0.1rem;
}
.bottom-fixed {
  position: fixed;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 80px;
  z-index: 1000; /* 确保在其他元素上方 */
  background-color: white; /* 添加背景色，防止透明时看到后面内容 */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* 可选：添加阴影，使其与内容分离 */
}
.footer-content .van-button {
  border-radius: 10px !important; /* 四个角都设置 */
}

.mock-login-page {
  min-height: 100vh;
  padding: 32px 20px 88px;
  background:
    radial-gradient(circle at top left, rgba(47, 128, 237, 0.18), transparent 36%),
    radial-gradient(circle at bottom right, rgba(15, 23, 42, 0.12), transparent 32%),
    linear-gradient(180deg, #f5f7fb 0%, #edf2f7 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mock-login-card {
  width: 100%;
  max-width: 420px;
  padding: 32px 24px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.12);
}

.mock-login-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 108px;
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(47, 128, 237, 0.12);
  color: #2f80ed;
  font-size: 13px;
  font-weight: 600;
}

.mock-login-title {
  margin-top: 18px;
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.mock-login-subtitle {
  margin-top: 10px;
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

.mock-login-form {
  margin-top: 28px;
}

.mock-input {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  min-height: 58px;
  padding: 12px 16px;
  border: 1px solid #dbe3ef;
  border-radius: 14px;
  background: #f8fafc;
}

.mock-input + .mock-input {
  margin-top: 14px;
}

.mock-input-label {
  font-size: 13px;
  color: #334155;
  font-weight: 600;
}

.mock-input-placeholder {
  font-size: 14px;
  color: #94a3b8;
}

.mock-login-options {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #64748b;
}

.mock-login-button {
  margin-top: 22px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(90deg, #2f80ed 0%, #56ccf2 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 2px;
}

.beian-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  text-align: center;
  padding: 0 16px;
}

.beian-link {
  color: #64748b;
  font-size: 13px;
  text-decoration: none;
}

.beian-link:hover {
  color: #2f80ed;
  text-decoration: underline;
}

@media (max-width: 480px) {
  .mock-login-page {
    padding: 20px 16px 84px;
  }

  .mock-login-card {
    padding: 28px 18px 24px;
    border-radius: 18px;
  }

  .mock-login-title {
    font-size: 26px;
  }
}
// html {
//     font-size: 18px;
//     background-color: #f8f8f8;
// }

</style>
